function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1253.32,234.52a8.47,8.47,0,0,0-8.46-8.46,8.47,8.47,0,0,0-8.46,8.46,8.47,8.47,0,0,0,8.46,8.46,8.47,8.47,0,0,0,8.46-8.46h0Zm-8.46,2.82a2.82,2.82,0,0,1-2.82-2.82,2.82,2.82,0,0,1,2.82-2.82,2.82,2.82,0,0,1,2.82,2.82,2.82,2.82,0,0,1-2.82,2.82h0Zm0,0",
  transform: "translate(1299.46 -214.28)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1262.48,244.91c-8,0-13,6.49-13,14.46v5.78c0,1.6.58,1.33,2.18,1.33h23.13c1.6,0,.78.27,0.78-1.33v-5.78c0-8-5.08-14.46-13-14.46h0Zm6.52,15h-13v-0.59c0-4.78,1.74-8.67,6.52-8.67s6.52,3.89,6.52,8.67V260Zm2.85,2.3",
  transform: "translate(1299.46 -214.28)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1250.22,270.83h-23.13a3.23,3.23,0,0,0-2.89,3.26,3.23,3.23,0,0,0,2.89,3.26h23.13a3.23,3.23,0,0,0,2.89-3.26,3.23,3.23,0,0,0-2.89-3.26h0Zm0,3",
  transform: "translate(1299.46 -214.28)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1250.22,283.88h-23.13a3.23,3.23,0,0,0-2.89,3.26,3.23,3.23,0,0,0,2.89,3.26h23.13a3.23,3.23,0,0,0,2.89-3.26,3.23,3.23,0,0,0-2.89-3.26h0Zm0,1.51",
  transform: "translate(1299.46 -214.28)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1200.87,250a2.89,2.89,0,0,0-.85-2l-8.18-8.18a2.4,2.4,0,0,0-3.66,0l-9.78,10.21V236.23a3.43,3.43,0,0,0-1.27-2l-17.56-17.54-0.11-.76c-0.53-.53-1.37-1.61-2.16-1.61h-40.48c-1.6,0-1.49,2.81-1.49,4.41v8.64h-10.27a3,3,0,0,0-2.78,3.12v81.16c0,1.6,1.18,4.89,2.78,4.89h58c1.6,0,2.27-3.3,2.27-4.89v-8.15h9.3c1.6,0,3.75-2,3.75-3.6V274.52l22-22.48a2.62,2.62,0,0,0,.42-2h0Zm-28.26,21.28-0.92.92-6.13,2,2-6.13,13.83-13.83,4.09,4.09Zm-11.6-45.56,6.72,8.13h-6.72v-8.13Zm-2.17,84.25h-50V233.85h6.52v66c0,1.6-.11,3.6,1.49,3.6h42V310Zm-37-13V220.81h30.45v15.43c0,1.6,3.4,4.15,5,4.15h14.58v15.39l-8.79,8.74a3,3,0,0,0-.73,1.13l-4.1,12.27a2.89,2.89,0,0,0,.69,3,3,3,0,0,0,3,.7l9.92-3.29v18.65h-50Zm67.75-42.64-4.09-4.09,4.28-4.28,4.09,4.09Zm0,0",
  transform: "translate(1299.46 -214.28)"
});

var SvgJobsApplicationsIcon = function SvgJobsApplicationsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 98.6 102.22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobsApplicationsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/JobsApplications_icon.e8e4bcb2.svg";
export { ForwardRef as ReactComponent };